import React from "react";
import {
  Button,
  IconButton,
  Table,
  TableContainer,
  TableRow,
  TableHead,
  TableBody,
  TableCell,
  Chip
} from "@material-ui/core";
import useStyles from "./styles";
import StarBorderRoundedIcon from '@material-ui/icons/StarBorderRounded';
import StarRateRoundedIcon from '@material-ui/icons/StarRateRounded';

const states = {
  done: "success",
  processing: "warning",
  declined: "secondary",
};

const KEY_ARRAY= ['ID', 'Status', 'DownloadURL', 'Voice', 'Language', 'Engine', 'Star', 'CreatedAt'];

export default function TableComponent({ onStarClick, data }) {

  const classes = useStyles();
  if(!Array.isArray(data) || !data.length || !data[0]) {
    return (null);
  }

  return (
    <TableContainer>
      <Table className="mb-0">
      <TableHead>
        <TableRow>
          {KEY_ARRAY.map(key => (
            <TableCell style={{
            }} key={key}>{key}</TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((element) => {
          let { id, voice, url, status, languageCode, engine, isStarred, createdAt} = element;
          return (
          <TableRow key={id}>
            <TableCell className="pl-3 fw-normal">{id}</TableCell>
            <TableCell>
              <Chip label={status} classes={{root: classes[states[status.toLowerCase()]]}}/>
            </TableCell>
            <TableCell>
              {
                url ?
                <Button
                  target="_blank"
                  href={url}
                  color="primary"
                  variant="contained"
                >
                  Download
                </Button> :
                <Button
                  disabled
                  variant="contained"
                >
                  Not Available
                </Button>
              }
            </TableCell>
            <TableCell>{voice}</TableCell>
            <TableCell>{languageCode}</TableCell>
            <TableCell>{engine}</TableCell>
            <TableCell>{
              isStarred ?
                <IconButton color="primary" aria-label="starred" onClick={() =>onStarClick(id, !isStarred)}>
                  <StarRateRoundedIcon />
                </IconButton>
               :
               <IconButton color="primary" aria-label="notstarred" onClick={() =>onStarClick(id, !isStarred)}>
                <StarBorderRoundedIcon />
              </IconButton>
              }
            </TableCell>
            <TableCell>{createdAt}</TableCell>
          </TableRow>
          )
        })}
      </TableBody>
    </Table>
    </TableContainer>

  );
}
